import { render, staticRenderFns } from "./pessoa-juridica.vue?vue&type=template&id=81ea5722&"
import script from "./pessoa-juridica.vue?vue&type=script&lang=js&"
export * from "./pessoa-juridica.vue?vue&type=script&lang=js&"
import style0 from "./pessoa-juridica.vue?vue&type=style&index=0&id=81ea5722&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports